import { render, staticRenderFns } from "./BrandsDropDown.vue?vue&type=template&id=82b847e2&scoped=true&"
import script from "./BrandsDropDown.vue?vue&type=script&lang=js&"
export * from "./BrandsDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b847e2",
  null
  
)

export default component.exports